import React from 'react';

// Mensagem de "sem registros" das tabelas de busca — centralizada na área visível,
// igual ao TabelaLoading (mesma classe .tabela-msg). Ver src/css/tabela-loading.css.
const TabelaVazia = ({ texto = 'Nenhum registro' }) => (
    <div className="tabela-msg">
        <span>{texto}</span>
    </div>
);

export default TabelaVazia;
